import * as Styled from './Avatar.styles';

const Avatar = ({ icon, src, alt = 'avatar', size = 'md' }) => {
  return (
    <Styled.Avatar size={size} className="glass-border">
      {icon && <Styled.Icon size={size} variant={icon} />}
      {src && <Styled.Img src={src} alt={alt} />}
    </Styled.Avatar>
  );
};

export default Avatar;
